import { render } from "./AsBannersTop.vue?vue&type=template&id=6dc5d498&ts=true"
import script from "./AsBannersTop.vue?vue&type=script&lang=ts"
export * from "./AsBannersTop.vue?vue&type=script&lang=ts"

import "./AsBannersTop.vue?vue&type=style&index=0&id=6dc5d498&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__